export const DEFAULTER_LABELS = ['inadimplente_com_a_escola', 'inadimplente_com_a_kedu'];